"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
function pick() {
    var keys = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        keys[_i] = arguments[_i];
    }
    return function (obj) { return keys.reduce(function (a, e) {
        var _a;
        return (__assign(__assign({}, a), (_a = {}, _a[e] = obj[e], _a)));
    }, {}); };
}
exports.pick = pick;
function objectHasAnyKey(obj, keys, prependKey) {
    var inObj = function (obj, key) {
        var res = formik_1.getIn(obj, key, '_NONE_');
        return res === '_NONE_' ? false : res;
    };
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        var comKey = prependKey ? "" + prependKey + key : key;
        if (obj[comKey] || inObj(obj, comKey)) {
            return true;
        }
    }
    return false;
}
exports.objectHasAnyKey = objectHasAnyKey;
function objectHasAnyKeyRegex(obj, regex) {
    var keys = Object.keys(obj);
    for (var _i = 0, keys_2 = keys; _i < keys_2.length; _i++) {
        var key = keys_2[_i];
        if (key.search(regex) > -1) {
            return true;
        }
    }
    return false;
}
exports.objectHasAnyKeyRegex = objectHasAnyKeyRegex;
//# sourceMappingURL=objectHelpers.js.map